module.exports = "img/element-icons/new-and-improved.65a63c7.svg";